import { BaseApiService } from '@/_services/baseApi.service'

export class EkyzmatService extends BaseApiService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  ekyzmatLogin () {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/auth/ekyzmat/login`
    return this.sendGetRequest(url).then((res) => {
      window.location.href = res.link
    })
  }

  authenticate (code, state) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/auth/ekyzmat/authenticate?code=${code}&state=${state}`
    return this.sendPostRequest(url, null)
  }
}

export default new EkyzmatService()
